/**
 * Windows-1252 byte 0x99 is the trademark sign. When that byte is decoded as
 * Latin-1 it becomes U+0099, a C1 control character. Chrome does not paint it,
 * so the title shows a blank gap. Safari substitutes the cp1252 glyph, which
 * does not match the site font. U+2122 is the real trademark sign.
 */
const MISENCODED_TRADEMARK = '\u0099';

export const decodeEntityString = (name?: string) =>
    name
        ? name
              .replace(/&trade;/g, '™')
              .replace(/&#8482;|&#x2122;/gi, '™')
              .replace(/&#153;|&#x99;/gi, '™')
              .replaceAll(MISENCODED_TRADEMARK, '™')
              .replace(/&amp;/g, '&')
        : '';
